import { takeEvery } from "@redux-saga/core/effects";
import { ConfigActionTypes } from "./../types";
import { changeConfig } from "./changeConfigs";

export default function* ConfigsSaga() {
    yield takeEvery(ConfigActionTypes.CHANGE_CONFIGS_REQUEST, changeConfig);
}
